var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _vm.loading
      ? _c("div", [_c("pickstar-loading")], 1)
      : _c("div", [
          _c(
            "div",
            { staticClass: "dashboard-page-title" },
            [
              _vm._v("\n      Tree\n      "),
              _vm._l(_vm.tree, function (item) {
                return _c("system-tag-tree-item", {
                  key: item.id,
                  attrs: { item: item },
                  on: {
                    refreshTree: _vm.getTree,
                    editing: () => {
                      this.loading = true
                    },
                  },
                })
              }),
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "div",
            [
              _vm._v(
                "\n      Uncategorized Tags - " +
                  _vm._s(
                    _vm.pagination.total
                      ? "Showing " +
                          (_vm.tags ? _vm.tags.length : 0) +
                          "/" +
                          _vm.pagination.total
                      : ""
                  ) +
                  "\n      "
              ),
              _c(
                "div",
                { staticClass: "flex flex-row" },
                [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.search,
                        expression: "search",
                      },
                    ],
                    staticClass: "form-control",
                    attrs: { placeholder: "Search...", type: "text" },
                    domProps: { value: _vm.search },
                    on: {
                      keypress: function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        )
                          return null
                        return _vm.getUncategorizedTags.apply(null, arguments)
                      },
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.search = $event.target.value
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c("selectize", {
                    staticClass: "selectize selectize-single form-control",
                    attrs: {
                      placeholder: "Type",
                      name: "tag_type",
                      options: _vm.tagTypeOptions,
                      "disable-delete": true,
                    },
                    on: { input: _vm.getUncategorizedTags },
                    model: {
                      value: _vm.type,
                      callback: function ($$v) {
                        _vm.type = $$v
                      },
                      expression: "type",
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "ladda-button",
                    {
                      staticClass: "button btn-primary",
                      attrs: { click: _vm.getUncategorizedTags },
                    },
                    [_vm._v("Search")]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _vm._l(_vm.tags, function (item) {
                return _c("system-tag-tree-item", {
                  key: item.id,
                  attrs: { item: item },
                  on: {
                    refreshTree: _vm.getTree,
                    editing: () => {
                      this.loading = true
                    },
                  },
                })
              }),
              _vm._v(" "),
              _c(
                "lazy-loading",
                {
                  ref: "lazyLoading",
                  staticClass: "text-center",
                  attrs: {
                    loading: _vm.loading,
                    "reached-bottom": _vm.getNextUncategorizedTags,
                  },
                },
                [
                  _c("pickstar-loading", {
                    attrs: { slot: "loading" },
                    slot: "loading",
                  }),
                  _vm._v(" "),
                  _c("span", { attrs: { slot: "finished" }, slot: "finished" }),
                ],
                1
              ),
            ],
            2
          ),
        ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }